export enum EAttachmentStatus {
  TO_BE_SIGNED = 'TO_BE_SIGNED',
  SIGNED = 'SIGNED',
}
